import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-entfernen-multi';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunktionsbereichEntfernenMultiEffects {

    FunktionsbereichEntfernenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI),
        mergeMap((x: ac.PostFunktionsbereichEntfernenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichEntfernenMulti(x.funktionsbereichEntfernenMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichEntfernenMultiErfolgreichAction(result, x.funktionsbereichEntfernenMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichEntfernenMultiFehlerAction(error, x.funktionsbereichEntfernenMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheCommandService);
        }
        return this.service;
    }
}
